import { Link } from 'react-router-dom';
import './style.scss';
type Props = {
    contentType: string;
    imageSrc: string | undefined;
    title: string;
    cta: string;
};

export default function HomePageCard({ contentType, imageSrc, title, cta }: Props) {
    return (
        <div className="HomePageCard">
            <div className="content-type">{contentType}</div>
            <Link to={cta} className="wrapper">
                <div className="image-wrapper">
                    <img src={imageSrc} />
                </div>
                <div className="title">{title}</div>
            </Link>
        </div>
    );
}
